import styled from 'vue-styled-components';
const ColorSpace = styled.div`
    position: relative;
    display: inline-block;
`
const TopSection = styled.div`
    border-radius: 2px;
    height: 160px;
    overflow: hidden;
`
const SelectArea = styled.div`
    display: inline-block;
    position: relative;
    height: 100%;
    width: 160px;
    cursor: crosshair;
`
/* background-color: rgb(255, 0, 0); */
const SelectorLayer = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;

  &.brightness-layer {
    background-image: linear-gradient(180deg,hsla(0,0%,100%,0),#000);
  }
  &.saturation-layer {
    background-image: linear-gradient(90deg,#fff,hsla(0,0%,100%,0));
    }
`
const ColorIndicator = styled.div`
    margin-top: 16px;
    height: 13px;
    width: 13px;
    border: 2px white solid;
    border-radius: 22px;
    position: absolute;
    cursor: crosshair;
    z-index: 10;
`
const HueScale = styled.div`
    width: 100%;
    height: 10px;
    position: relative;
    background-image: linear-gradient(90deg,red 0,#ff4d00 5%,#f90 10%,#ffe600 15%,#cf0 20%,#80ff00 25%,#3f0 30%,#00ff1a 35%,#0f6 40%,#00ffb3 45%,#0ff 50%,#06f 60%,#001aff 65%,#30f 70%,#8000ff 75%,#c0f 80%,#ff00e6 85%,#f09 90%,#ff004d 95%,red);
`
const HueIndicatorProps = {
  color: String
}
const HueIndicator = styled('input', HueIndicatorProps)`
  border-radius: 6px;
  position: absolute;
-webkit-appearance: none;
  width: 100%;
  height: 10px;
  background: transparent;
  outline: none;
  -webkit-transition: .2s;
  transition: opacity .2s;

&::-webkit-slider-thumb {
  -webkit-appearance: none;
  appearance: none;
  width: 20px;
  height: 20px;
  background: ${({ color }) => color};
  cursor: pointer;
  border: 3px solid white;
  border-radius: 50%;
  box-shadow: 0 1px 3px 0 rgb(52 94 151 / 60%);
}

&::-moz-range-thumb {
    width: 20px;
    height: 20px;
    background: ${({ color }) => color};
    cursor: pointer;
    border: 3px solid white;
    border-radius: 50%;
    box-shadow: 0 1px 3px 0 rgb(52 94 151 / 60%);
}

input[type=”range”]::-webkit-slider-runnable-track{
  -webkit-appearance: none;
  border-radius: 6px;
}
`


export { ColorSpace, TopSection, SelectArea, SelectorLayer, ColorIndicator, HueScale, HueIndicator }